export const vehicleTypes = {
	car: 'Bil',
	bus: 'Buss',
	taxi: 'Taxi',
}
